import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatTime'
})
export class ParseTimePipe implements PipeTransform {
  transform(val: any | null): any {
    if (!val || val.length < 2) {
      return '';
    }
    let newTime = new Date();
    if (val.length > 3) {
      newTime.setHours(val[3]);
      newTime.setMinutes(val[4]);
    } else {
      newTime.setHours(val[0]);
      newTime.setMinutes(val[1]);
    }
    return newTime;
  }

}
